<ng-container *ngIf="(registrationStage$ | async) === RegistrationStage.DataError">
  <glxy-alert type="error" [showAction]="true" actionTitle="Learn more" (actionClick)="openLearnMoreModal()">
    <span class="bold"> {{ 'SMS_REGISTRATION.ALERT.REJECTED_TITLE' | translate }} -</span>
    {{ 'SMS_REGISTRATION.ALERT.REJECTED_SUGGESTION' | translate }}
  </glxy-alert>
</ng-container>
